import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/service/base-service';
import { AuthUtilsService } from 'src/app/core/util/auth-utils.service';
import { CategoryTypeModel } from '../model/category-type-model';

@Injectable({
  providedIn: 'root',
})
export class CategoryTypeService extends BaseService<CategoryTypeModel> {
  pagination: { pageIndex: number; perPage: number };
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'partyTypeCategory';
  }

  validate(): boolean {
    return false;
  }
}
